import { LayerType } from '../../shared/model/layers/layer-types'

export const isSelectionAnnotationLayer = (layer: {
    name?: string | null
    isSelectable?: boolean
    type?: LayerType | string
}): boolean => layer.type === LayerType.Annotation && !!layer.isSelectable

export const isManagedLayer = (layer: {
    name?: string | null
    isSelectable?: boolean
    type?: LayerType | string
}): boolean => !isSelectionAnnotationLayer(layer)
